import { createContext, useContext, useEffect, useState } from 'react';
import { onSnapshot, doc, setDoc } from 'firebase/firestore';
import { db } from './firebase_init';
import { useDialog } from '../Routes/DialogManager';

function getByPath(obj, path) {
  return path
    .replace(/\[(\w+)\]/g, '.$1')
    .split('.')
    .reduce((o, k) => (o ? o[k] : undefined), obj);
}

function setByPath(obj, path, value) {
  const keys = path.split('.');
  const lastKey = keys.pop();

  const target = keys.reduce((o, k) => {
    if (!o[k]) o[k] = {};
    return o[k];
  }, obj);

  target[lastKey] = value;
}

const FirestoreContext = createContext(null);

export const FirestoreProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const { setDialog, setLoading, loading } = useDialog();

  useEffect(() => {
    const unsubscribe = onSnapshot(doc(db, 'data', 'mainpage'), (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.data();
        setData(data);
        console.log("Firestore: ", data);
      }
    });
    return () => unsubscribe();
  }, []);

  const saveData = async () => {
    try {
      if (loading) return;
      console.log(data);
      setLoading(true);
      await setDoc(doc(db, 'data', 'mainpage'), data);

      setLoading(false);
    } catch (e) {
      setDialog("Nepovedlo se uložit: ", e?.message);
      setLoading(false);
    }
  }

  function setByPath(obj, path, value) {
    const keys = path.split('.');
    const lastKey = keys.pop();

    const target = keys.reduce((o, k) => {
      if (!o[k]) o[k] = {};
      return o[k];
    }, obj);

    target[lastKey] = value;
  }

  const changeData = async (key, data, path) => {
    if (key) {
      setData(prev => ({
        ...prev,
        [key]: data,
      }));
    } else if (path) {
      setData(prev => {
        const copy = structuredClone(prev);
        setByPath(copy, path, data);
        return copy;
      });
    }

  }

  const getData = (key, path) => {
    try {
      if (!data) return "";
      if (key) {
        return data?.[key] || "";
      } else if (path) {
        return getByPath(data, path);
      }
    } catch (e) {
      return "";
    }
  }


  return (
    <FirestoreContext.Provider value={{ data, getData, saveData, changeData }}>
      {children}
    </FirestoreContext.Provider>
  );
};

export const useFirestore = () => useContext(FirestoreContext);
